import React, { useEffect, useRef } from 'react';
import { ArrowDown } from 'lucide-react';

type ExpandMoreProps = {
	isCollapsed: boolean;
	toggleExpand: () => void;
	title: string;
	body: JSX.Element | string;
};

export const ExpandMore = (props: ExpandMoreProps) => {
	const collapsedContentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (collapsedContentRef.current) {
			if (props.isCollapsed) {
				collapsedContentRef.current.style.maxHeight = '0px';
			} else {
				collapsedContentRef.current.style.maxHeight =
					collapsedContentRef.current.scrollHeight + 'px';
			}
		}
	}, [props.isCollapsed]);
	return (
		<>
			<div
				style={{ display: 'flex', gap: 12, alignItems: 'center' }}
				onClick={props.toggleExpand}
			>
				<div>{props.title}</div>

				<ArrowDown
					size={16}
					style={{
						transform: props.isCollapsed
							? 'rotate(0deg)'
							: 'rotate(180deg)',
						transition: 'transform 0.2s ease-in-out',
					}}
				/>
			</div>

			<div
				ref={collapsedContentRef}
				style={{
					maxHeight: 500,
					overflow: 'hidden',
					transition: 'max-height 0.2s ease-in-out',
				}}
			>
				<p>{props.body}</p>
			</div>
		</>
	);
};
